"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import HeroProvinceBar from "@/components/HeroProvinceBar";

export default function TopSearchBar() {
  const pathname = usePathname();

  // Track search submissions from topbar
  useEffect(() => {
    // This will be called after navigation happens
    // We can track the navigation change here if needed
  }, [pathname]);

  return (
    <div className="topbar-search" role="search" aria-label="Cerca sagre">
      <HeroProvinceBar
        placeholder="Vicino a me"
        ctaLabel="CERCA"
        // Don't pass onSubmit - let HeroProvinceBar handle routing automatically
        // It will route to /vicino-a-me/ for "Vicino a me" or to /sagre/[regione]/[provincia]/ for provinces
      />
    </div>
  );
}

